import script from "./base.vue?vue&type=script&lang=jsx"
export * from "./base.vue?vue&type=script&lang=jsx"

import "./base.vue?vue&type=style&index=0&id=8d27da9a&lang=scss"

const __exports__ = script;

export default __exports__